<template>
  <div>
    <clip-loader v-show="loading" />
    <div class="table-responsive">
      <table v-if="!loading" class="table table-hover interactive-table">
        <thead class="sortable-table-header">
          <tr>
            <th
              class="sort-by"
              :class="currentSortBy === 'name' ? 'table-active' : ''"
              @click="$emit('sort', 'name')"
            >
              {{ trans("center.name") }}
              <i :class="sortIconClass('name')" />
            </th>
            <th>{{ trans("forms.hsaId") }}</th>
            <th v-if="showRegion">{{ trans("region.region") }}</th>
            <th>{{ trans("center.primaryUsers") }}</th>
            <th
              class="sort-by"
              :class="currentSortBy === 'created_at' ? 'table-active' : ''"
              @click="$emit('sort', 'created_at')"
            >
              {{ trans("examination.createdAtLabel") }}
              <i :class="sortIconClass('created_at')" />
            </th>
            <th v-if="showDeletedAt">{{ trans("center.deletedAt.label") }}</th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="center in centers"
            :key="center.id"
            :class="{ last: highlightedId === center.id }"
            :data-test="`centers-table-row-${center.id}`"
            @click="$emit('open', center.id)"
          >
            <td>{{ center.name }}</td>
            <td>{{ center.hsa_id }}</td>
            <td v-if="showRegion">{{ center.regionName }}</td>
            <td>{{ center.total_users }}</td>
            <td>{{ center.created_at_formatted }}</td>
            <td v-if="showDeletedAt">{{ center.deleted_at_formatted }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import ClipLoader from "../../Utils/ClipLoader.vue";

export default {
  name: "CentersTable",
  components: { ClipLoader },
  props: {
    centers: {
      type: Array,
      required: true,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    currentSortBy: {
      type: String,
      required: true,
    },
    sortOrder: {
      type: String,
      required: true,
    },
    showRegion: {
      type: Boolean,
      default: false,
    },
    showDeletedAt: {
      type: Boolean,
      default: false,
    },
    highlightedId: {
      type: Number,
      default: null,
    },
  },
  methods: {
    sortIconClass(column) {
      if (this.currentSortBy === column && this.sortOrder === "asc") {
        return "fas fa-caret-up";
      }
      return "fas fa-caret-down";
    },
  },
};
</script>
